import { featureFlags } from 'services/featureFlags/featureFlags';
import {
  ENABLE_FEATURE,
  FEATURES,
  FETCH_FEATURES_ERROR,
  FETCH_FEATURES_REQUEST,
  FETCH_FEATURES_SUCCESS,
} from '../../constants';

export const enableFeature = feature => ({
  type: ENABLE_FEATURE,
  payload: { [feature]: true },
});

export const fetchFeatures = () => (dispatch, _getState) => {
  dispatch({ type: FETCH_FEATURES_REQUEST });

  return featureFlags
    .fetch(FEATURES)
    .then(payload => dispatch({ type: FETCH_FEATURES_SUCCESS, payload }))
    .catch(() => dispatch({ type: FETCH_FEATURES_ERROR }));
};
